// This file is used to store the configuration for the application except that baseUrl is set in main.js
const snsConfig = {
  baseUrl: 'https://stats3cx.snsolutions.fr',
  siteUrl: 'https://snsolutions.fr',
  web3cxUrl: 'https://snsolutions.3cx.fr/#/login',
  logoUrl: 'https://www.snsolutions.fr/wp-content/uploads/2024/02/cropped-logo-sns-20-bis.png'
}

let store = snsConfig // change this

let defaultConfig = {
  api: {
    apiUser: null,
    apiPassword: null,
    host3cx: null,
    apiAiActive: null,
    apiRecordings: null,
    api3cx: null,
    api3cxUrl: null
  },
  whisperApiServerAddress: "https://whisper-backend.snsolutions.fr/api",
}
store = {...store,...defaultConfig}

export default store